import { Modal, Button } from "react-bootstrap";

const ConfirmModalUnlockMessage = ({
  open,
  title,
  description,
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
  loading = false,
}) => {
  return (
    <Modal
      show={open}
      onHide={onCancel}
      centered
      backdrop="static"
      keyboard={!loading}
    >
      <Modal.Body className="p-4">
        <h5 className="fw-semibold mb-2">{title}</h5>

        <p className="text-muted mb-4">{description}</p>

        <div className="d-flex justify-content-end gap-2">
          <Button
            variant="outline-secondary"
            onClick={onCancel}
            disabled={loading}
          >
            {cancelText}
          </Button>

          <Button variant="danger" onClick={onConfirm} disabled={loading}>
            {loading ? "Please wait..." : confirmText}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmModalUnlockMessage;
